'use client';

/**
 * __name runtime polyfill component.
 *
 * esbuild / SWC (Next.js Turbopack, OpenNext/Cloudflare build) inject
 * `__name(fn, "Name")` calls into every module for function-name
 * preservation.  When a lazy chunk evaluates before the helper-definition
 * chunk has loaded, or when the Creatr live-preview evaluates extracted
 * component code in a fresh scope, `__name` is undefined → ReferenceError.
 *
 * This MUST be a "use client" component.  React 19 hoists <script> tags
 * rendered from server components; client-component scripts are rendered
 * as-is at their position in the HTML stream.  Placing this at the top of
 * <body> ensures a synchronous inline <script> appears before any async
 * chunk scripts can execute (async scripts queue while the HTML parser runs
 * through any synchronous inline script it encounters).
 *
 * The nonce is applied during SSR (`typeof window === 'undefined'`) so the
 * CSP allows the script.  On the client during hydration the nonce is
 * omitted — React reconciles the existing DOM node without re-executing it.
 */
export function NamePolyfill({ nonce }: { nonce?: string }) {
  return (
    <script
      // Polyfill must match esbuild's __name signature exactly:
      //   var __name = (target, value) =>
      //     Object.defineProperty(target, "name", { value, configurable: true });
      dangerouslySetInnerHTML={{
        __html: `if(typeof __name==="undefined"){window.__name=function(t,n){try{Object.defineProperty(t,"name",{value:n,configurable:!0})}catch(e){}return t}}`,
      }}
      nonce={typeof window === 'undefined' ? nonce : ''}
      suppressHydrationWarning
    />
  );
}
